import { Toast, Tooltip } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));

	document.addEventListener("DOMContentLoaded", function () {
		document.querySelectorAll('.splide').forEach((s) => {
			var slider = s.splide;
			var isVisible = s.querySelectorAll('.is-visible');
			if (isVisible.length >= slider.length) {
				slider.Components.Arrows.destroy();
				s.querySelectorAll('.splide__progress')[0].remove();
			}
		});
	});

})();
